module.exports = __webpack_public_path__ + "static/media/LogicWedge6_2_row_1.7bd82743.png";